import type { Lang } from '@/types/lang'

export type Language = Lang

const translations = {
  ru: {
    // Header
    searchPlaceholder: 'Найти курс',
    profile: 'Профиль',
    logout: 'Выход',
    courseAuthor: 'Автор курсов',

    // Sidebar
    myCourses: 'Мои курсы',
    catalog: 'Каталог',
    analytics: 'Аналитика',
    settings: 'Настройки',

    // Dashboard
    createCourse: 'Создать курс',
    editCourse: 'Редактировать',
    deleteCourse: 'Удалить',
    publishCourse: 'Опубликовать',
    unpublishCourse: 'Снять с публикации',

    // Course
    lessons: 'Уроки',
    slides: 'Слайды',
    minutes: 'мин',

    // Common
    save: 'Сохранить',
    cancel: 'Отмена',
    delete: 'Удалить',
    edit: 'Редактировать',
    add: 'Добавить',
    back: 'Назад',
    next: 'Далее',
    finish: 'Завершить',
    loading: 'Загрузка...',
    error: 'Ошибка',
    success: 'Успешно',

    // Auth
    signIn: 'Войти',
    signUp: 'Регистрация',
    email: 'Email',
    password: 'Пароль',
    forgotPassword: 'Забыли пароль?',
    noAccount: 'Нет аккаунта?',
    hasAccount: 'Уже есть аккаунт?',

    // Messages
    courseCreated: 'Курс создан',
    courseSaved: 'Курс сохранен',
    courseDeleted: 'Курс удален',
    coursePublished: 'Курс опубликован',
    signedOut: 'Вы вышли из аккаунта',
    langUndeclared: 'Перевод готов, но язык не объявлен — в каталоге на этом языке курса нет',
  },
  en: {
    // Header
    searchPlaceholder: 'Find a course',
    profile: 'Profile',
    logout: 'Sign out',
    courseAuthor: 'Course author',

    // Sidebar
    myCourses: 'My courses',
    catalog: 'Catalog',
    analytics: 'Analytics',
    settings: 'Settings',

    // Dashboard
    createCourse: 'Create course',
    editCourse: 'Edit',
    deleteCourse: 'Delete',
    publishCourse: 'Publish',
    unpublishCourse: 'Unpublish',

    // Course
    lessons: 'Lessons',
    slides: 'Slides',
    minutes: 'min',

    // Common
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    back: 'Back',
    next: 'Next',
    finish: 'Finish',
    loading: 'Loading…',
    error: 'Error',
    success: 'Success',

    // Auth
    signIn: 'Sign in',
    signUp: 'Sign up',
    email: 'Email',
    password: 'Password',
    forgotPassword: 'Forgot password?',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',

    // Messages
    courseCreated: 'Course created',
    courseSaved: 'Course saved',
    courseDeleted: 'Course deleted',
    coursePublished: 'Course published',
    signedOut: 'You have been signed out',
    langUndeclared:
      'The translation is ready, but the language isn’t turned on — the course won’t appear in the catalog in this language',
  },
} as const

export type TranslationKey = keyof typeof translations.ru

export function t(key: TranslationKey, language: Language): string {
  return translations[language][key] || translations.ru[key] || key
}
